import React from 'react'
import PrivateRoutes from '../Route'
import List from '../../pages/Commercial/Proposals/List'
import Create from '../../pages/Commercial/Proposals/Create'
import View from '../../pages/Commercial/Proposals/View'
import Update from '../../pages/Commercial/Proposals/Update'
import { CustomSwitch } from '../../components/CustomSwitch'

export const ProposalsRouter = (): JSX.Element => (
  <CustomSwitch>
    <PrivateRoutes path="/commercial/proposals" exact component={List} />
    <PrivateRoutes
      path="/commercial/proposals/create"
      exact
      component={Create}
    />
    <PrivateRoutes
      path="/commercial/proposals/view/:id"
      exact
      component={View}
    />
    <PrivateRoutes
      path="/commercial/proposals/update/:id"
      exact
      component={Update}
    />
  </CustomSwitch>
)
